import { render, staticRenderFns } from "./ColorsProduct.vue?vue&type=template&id=4eea01fa&"
import script from "./ColorsProduct.vue?vue&type=script&lang=js&"
export * from "./ColorsProduct.vue?vue&type=script&lang=js&"
import style0 from "./ColorsProduct.vue?vue&type=style&index=0&id=4eea01fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports